import {
  getDocumentControllerGetByIdQueryKey,
  getDocumentControllerGetValidationReviewQueryKey,
  useDocumentControllerDecideValidation,
} from '@app/api-client';
import { useQueryClient } from '@tanstack/react-query';
import {
  KEY_PUBLICATION_PENDING,
  KEY_PUBLICATION_PUBLISHED,
  KEY_PUBLICATION_REJECTED,
} from '../../publication/hooks/usePublicationLists.js';
import { KEY_DOCUMENT, KEY_DOCUMENT_VALUES } from './useDocuments.js';

export function useDocumentValidationDecide(documentId: string) {
  const qc = useQueryClient();
  return useDocumentControllerDecideValidation({
    mutation: {
      onSuccess: () => {
        void qc.invalidateQueries({
          queryKey: getDocumentControllerGetValidationReviewQueryKey(documentId),
        });
        void qc.invalidateQueries({ queryKey: getDocumentControllerGetByIdQueryKey(documentId) });
        void qc.invalidateQueries({ queryKey: KEY_DOCUMENT(documentId) });
        void qc.invalidateQueries({ queryKey: KEY_DOCUMENT_VALUES(documentId) });
        void qc.invalidateQueries({ queryKey: KEY_PUBLICATION_PENDING });
        void qc.invalidateQueries({ queryKey: KEY_PUBLICATION_PUBLISHED });
        void qc.invalidateQueries({ queryKey: KEY_PUBLICATION_REJECTED });
        void qc.invalidateQueries({ queryKey: ['documents', 'list'] });
      },
    },
  });
}
